import React from "react";
import { StatusBadge } from "./StatusBadge";

const Footer: React.FC = () => (
  <footer className="py-4 px-6 text-sm text-muted-foreground bg-background/50 backdrop-blur-sm border-t border-border/40">
    <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
      <p>
        &copy; {new Date().getFullYear()} Myǃhū. Interactive environmental
        monitoring platform.{" "}
        <a href="/terms-and-privacy" className="underline hover:text-primary">
          Terms & Privacy
        </a>
      </p>
      <StatusBadge />
    </div>
  </footer>
);

export default Footer;
